import { get } from 'lodash'

export default {
  props: {
    // Biến lưu role cần set policy
    role: {
      type: Object,
      default: () => {}
    },
    // Biến lưu các policy code đang có trong DB của role
    rolePolicies: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      // Biến lưu các policy mới của role
      policies: []
    }
  },
  computed: {
    roleName() {
      return get(this.role, 'description', '').toLowerCase()
    }
  },
  created() {
    this.resetPolicies()
  },
  methods: {
    save() {
      this.$emit('updatePolicies', this.policies)
    },
    resetPolicies() {
      this.policies = [...this.rolePolicies]
    }
  },
  watch: {
    // Xử lý tình huống thay đổi role ở ConfigRoleFilter
    rolePolicies: {
      handler() {
        this.resetPolicies()
      },
      immediate: true
    }
  }
}
